// extracted by mini-css-extract-plugin
module.exports = {"container":"cartItem_container__3M4Mw","img":"cartItem_img__3VhS2","count":"cartItem_count__2X3ab"};